import React from 'react'
import './experience.css'
import {FaReact} from 'react-icons/fa'
import {BsBootstrapFill} from 'react-icons/bs'
import {TbBrandJavascript} from 'react-icons/tb'
import {AiFillHtml5} from 'react-icons/ai'
import {IoLogoCss3} from 'react-icons/io'
import {FaLaravel} from 'react-icons/fa'
import {FaPhp} from 'react-icons/fa'
import {FaNodeJs} from 'react-icons/fa'
import {SiFlask} from 'react-icons/si'
import {FaPython} from 'react-icons/fa'
import {DiMongodb} from 'react-icons/di'
import {GrMysql} from 'react-icons/gr'
export default function Experience() {
  return (
    <section id = "experience">
        <h5>what Skills I Have </h5>
        <h2>My Experience</h2>
        <div className="container experience_container">
              <div className="experience_frontend">

                  <h3>Frontend Development</h3>
                  <div className="expereince_content">
                        <article className="experience_details">
                              <FaReact className="experienc_icon"/>
                              <div>
                                  <h4>React</h4>
                                  <small className="text-light">
                                    experienced
                                  </small>
                              </div>
                        </article>
                        <article className="experience_details">
                              <BsBootstrapFill  className="experienc_icon"/>
                              <div>
                                <h4>BootStrap</h4>
                                <small className="text-light">
                                  experienced
                                </small>
                              </div>
                        </article>
                        <article className="experience_details">
                              < TbBrandJavascript className="experienc_icon"/>
                              <div>
                                  <h4>JS</h4>
                                  <small className="text-light">
                                    experienced
                                  </small>
                              </div>
                        </article>
                        <article className="experience_details">
                            <AiFillHtml5 className="experienc_icon"/>
                            <div>
                                <h4>HTML</h4>
                                <small className="text-light">
                                  experienced
                                </small>
                            </div>
                        </article>
                        <article className="experience_details">
                              <IoLogoCss3 className="experienc_icon"/>
                              <div>
                                  <h4>CSS</h4>
                                  <small className="text-light">
                                    experienced
                                  </small>
                              </div>
                        </article>
                    </div>
                </div>
                <div className="experience_backend">

                  <div className="backend">
                        <h3>Backend Development </h3>
                        <div className="expereince_content">
                                <article className="experience_details">
                                        <FaLaravel className="experienc_icon"/>
                                        <div>
                                        <h4>Laravel</h4>
                                        <small className="text-light">
                                          experienced
                                        </small>
                                      </div>
                                  </article>
                                  <article className="experience_details">
                                        <FaPhp className="experienc_icon"/>
                                        <div>
                                        <h4>PHP</h4>
                                        <small className="text-light">
                                          experienced
                                        </small>
                                        </div>
                                  </article>
                                  <article className="experience_details">
                                        < FaNodeJs className="experienc_icon"/>
                                        <div>
                                        <h4>Node.js</h4>
                                        <small className="text-light">
                                          experienced
                                        </small>
                                        </div>
                                  </article>
                                  <article className="experience_details">
                                      <FaPython className="experienc_icon"/>
                                      <div>
                                        <h4>Python</h4>
                                        <small className="text-light">
                                          intermidiate
                                        </small>
                                        </div>
                                  </article>
                                  <article className="experience_details">
                                        <SiFlask className="experienc_icon"/>
                                        <div>
                                        <h4>Flask</h4>
                                        <small className="text-light">
                                          intermidiate
                                        </small>
                                        </div>
                                        
                                  </article>
                                </div>
                                  
                              
                              <div className="database">
                              <h3>Database Design and Development</h3>
                                <div className="expereince_content">

                                        <article className="experience_details">
                                              <GrMysql className="experienc_icon"/>
                                                <div>
                                                  <h4>MYSQL</h4>
                                                  <small className="text-light">
                                                    experienced
                                                  </small>
                                                </div>
                                        </article>
                                        <article className="experience_details">
                                              <DiMongodb className="experienc_icon"/>
                                                <div>
                                                  <h4>Mongodb</h4>
                                                  <small className="text-light">
                                                    experienced
                                                  </small>
                                                </div>
                                        </article>
                                  </div>
                            </div>
                      </div>
                  </div>   
            </div>
    </section >
  )
}
